import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import {
    currentSelectedBsk,
} from '@core/_utils/tools.utils';
import { MessagesService } from '@core/_services/messages.service';
import { setCurrentSelectedBsk } from '@core/_utils/basket.utils';

@Component({
    selector: 'basket-param',
    templateUrl: 'basket-param.component.html',
    styleUrls: ['basket-param.component.scss'],
})
export class BasketParamComponent {    
    @Input() public bsk;
    @Input() public compactMode = false;
        
    public baseRoot;
    public storagePath;
    public currentSelectedBsk: currentSelectedBsk;
    public currentBasket: string;
    public currentBasketName: string;
    public currenBasketType: string;
    public basket: any[];
    public readVar = false;
    public usePreProcess = false;
    public preProcessName = '';
    public parameterList: any[];
    public ctrlDouble = [];
    public indexInputMode: string;

    constructor(protected _messageService: MessagesService) {}

    public ngOnInit() {
        this.baseRoot = '';
        this.storagePath = '';
        this.currentSelectedBsk = setCurrentSelectedBsk(this.bsk, null);
        this.currentBasket = this.currentSelectedBsk.bskLabel;
        this.currentBasketName = this.currentSelectedBsk.bskName;
        this.currenBasketType = this.currentSelectedBsk.bskType;
        this.basket = this.currentSelectedBsk.bskName;
        if (this.bsk.BaseRoot) {
            if (!Array.isArray(this.bsk.BaseRoot.Name)) {
                this.baseRoot = this.bsk.BaseRoot.Name;
            }
            if (!Array.isArray(this.bsk.BaseRoot.Path)) {
                this.storagePath = this.bsk.BaseRoot.Path;
            }
        }
        this.usePreProcess = this.currentSelectedBsk.bskUsePreProcess;
        this.preProcessName = this.currentSelectedBsk.bskPreProcessName;
        this.parameterList = this.currentSelectedBsk.bskParameterList;
        this.indexInputMode = this.currentSelectedBsk.bskIndexInputMode;
    }

    public ngOnChanges() {}

    public onSelectBasket(event, aData) {
        // if (!this.blockAddFile || this.allowClick === true) {
        //     this.selectBasket.emit({
        //         selected: event,
        //         data: aData,
        //     });
        // }
    }

    public trunc(aData) {
        if (aData.length > 30) {
            return aData.substring(0, 30);
        } else {
            return aData;
        }
    } 
    
    public updateUrl(aData) {
        aData.Information.url = aData.Information.defUrl;
    }
}
